module.exports = __webpack_public_path__ + "img/uk.0c8987c5.svg";